import project1 from '../Assets/project1.png'
import project2 from '../Assets/project2.png'
import project3 from '../Assets/project3.png'
import project4 from '../Assets/project4.png'

import html from '../Assets/skillslogo/html.png';
import css from '../Assets/skillslogo/css-3.png';
import js from '../Assets/skillslogo/js.png';
import bootstrap from '../Assets/skillslogo/bootstrap.svg';
import github from '../Assets/skillslogo/github_icon.png';
import java from '../Assets/skillslogo/java.png';
import mongodb from '../Assets/skillslogo/mongodb.jpg';
import sql from '../Assets/skillslogo/mysql.png';
import react from '../Assets/skillslogo/react.png';
import ts from '../Assets/skillslogo/typescript.png';
import gsap from '../Assets/skillslogo/GreenSock-GSAP.png';
import jquery from '../Assets/skillslogo/jquery-icon.png';
import node from '../Assets/skillslogo/node-js-icon.png';
import three from '../Assets/skillslogo/three-js-icon.png';
import postman from '../Assets/skillslogo/postman-icon.png';

import project_video1 from '../Assets/Portfolio_video.mp4'
import project_video2 from '../Assets/ipod_video.mp4'
import project_video3 from '../Assets/Studio_video.mp4'
import project_video4 from '../Assets/BallonBooth_video.mp4'


export const Worklist = [
  {
    id: 'Studio0005',
    img: project1,
    link: 'https://studio0005.netlify.app/',
    pstyle:
    {
      top: 2,
      right: 2,
    },
    video_src: project_video3,
  },
  {
    id: 'balloon_booth',
    img: project2,
    link: 'https://balloonbooth.netlify.app/',
    pstyle:
    {
      top: 18,
      right: 17,
    },
    video_src: project_video4,

  },
  {
    id: 'ipod',
    img: project3,
    link: 'https://digital-ipod.netlify.app/',
    pstyle:
    {
      top: 35,
      right: 32,
    },
    video_src: project_video2,
  },
  {
    id: 'portfolio',
    img: project4,
    link: 'https://vg-portfolio.netlify.app/',
    pstyle:
    {
      top: 55,
      right: 47,
    },
    video_src: project_video1,
  },
];



export const Skills = [
  [
    {
      id: 10,
      skill: 'Html5',
      logo: html,
      background: '#ff4b00',
      color: '#FFFFFF',
      whereLearned: ['School'],
      level: 'Advanced',
      percentage: 95,
      projects: ['Portfolio website', 'Pizza store UI'],
      description: 'Markup language for structuring web content. Applied extensively in projects with forms, media, and SEO practices.',
      journey: 'Used HTML5 in every project to build the basic structure of webpages and ensure semantic, accessible layouts.'
    },
    {
      id: 11,
      skill: 'Css3',
      logo: css,
      background: '#2196f3',
      color: '#FFFFFF',
      whereLearned: ['School'],
      level: 'Advanced',
      percentage: 95,
      projects: ['Responsive portfolio', 'Pizza store UI'],
      description: 'Styling language for responsive, interactive UIs. Used for layouts, grids, animations, and transitions in projects.',
      journey: 'Implemented CSS3 in every project, experimenting with layouts, transitions, and animations to improve visual appeal and interactivity.'
    },
    {
      id: 12,
      skill: 'JavaScript',
      logo: js,
      background: '#ffdf00',
      color: '#000000',
      whereLearned: ['School', 'Internship'],
      level: 'Intermediate',
      percentage: 85,
      projects: ['Balloon Booth project', 'Ride-sharing app prototype'],
      description: 'Core web language for logic and interactivity. Applied advanced concepts in Balloon Booth and ride-sharing apps.',
      journey: 'Created an interactive iPod project demonstrating circular dial functionality for games and music, showing practical JavaScript use.'
    },
    {
      id: 13,
      skill: 'React Js',
      logo: react,
      background: '#36454F',
      color: '#61dafb',
      whereLearned: ['Internship', 'School'],
      level: 'Intermediate',
      percentage: 87,
      projects: ['Ride-sharing prototype', 'Portfolio website'],
      description: 'Frontend library for building component-based UIs. Applied hooks, props, and state management in real projects.',
      journey: 'Loved building every project in React; all portfolio and work-section projects were created using this framework for reusability and efficiency.'
    },
    {
      id: 14,
      skill: 'Node Js',
      logo: node,
      background: '#90EE90',
      color: '#3c873a',
      whereLearned: ['Self-learned', 'School'],
      level: 'Intermediate',
      percentage: 60,
      projects: ['Simple REST API for ridesharing app'],
      description: 'JavaScript runtime for backend services. Built simple REST APIs and linked them with frontend apps.',
      journey: 'Best showcased in the BalloonBooth project, implementing multiple APIs covering all backend aspects, including data handling and server logic.'
    },
  ],
  [
    {
      id: 9,
      skill: 'Gsap',
      logo: gsap,
      background: '#cff3da',
      color: '#88ce02',
      whereLearned: ['Self-learned'],
      level: 'Intermediate',
      percentage: 85,
      projects: ['Portfolio animations'],
      description: 'Animation library for smooth, performance-optimized effects. Built creative transitions in portfolio projects.',
      journey: 'Inspired by Apple’s website animations, I learned GSAP and created my first animated portfolio with smooth transitions and interactive effects.'
    },
    {
      id: 7,
      skill: 'Git/Github',
      logo: github,
      background: 'black',
      color: '#4078c0',
      whereLearned: ['Internship', 'School'],
      level: 'Advanced',
      percentage: 85,
      projects: ['Version control on Balloon Booth project'],
      description: 'Version control for collaboration and code management. Managed repos, branches, and pull requests in projects.',
      journey: 'Used Git/Github at every stage of personal and academic projects to track changes, collaborate efficiently, and follow industry-standard workflows.'
    },
    {
      id: 2,
      skill: 'Three Js',
      logo: three,
      background: 0,
      color: '#333333',
      whereLearned: ['Self-learned'],
      level: 'Beginner',
      percentage: 40,
      projects: [],
      description: 'Used for creating 3D graphics and animations with WebGL. Basic experience in scene setup, objects, and simple animations.',
      journey: 'Learned for fun and created 3D environments like a haunted house and a bowling playing zone to experiment with immersive web experiences.'
    },

    {
      id: 6,
      skill: 'Postman',
      logo: postman,
      background: '#ee6d3f',
      color: '#FFF5E1',
      whereLearned: ['Internship'],
      level: 'Intermediate',
      percentage: 65,
      projects: ['Ride-sharing API testing'],
      description: 'API testing tool for designing and validating endpoints. Applied in internship to ensure reliable REST services.',
      journey: 'Started using Postman in internship to test API endpoints and structures, which also helped in personal full-stack projects.'
    },
    {
      id: 15,
      skill: 'C/Java',
      logo: java,
      background: '#FAF3E0',
      color: '#f89820',
      whereLearned: ['Coaching center', 'School'],
      level: 'Advanced',
      percentage: 90,
      projects: ['Basic OOP exercises', 'Data structures assignments'],
      description: 'Programming languages for OOP and algorithms. Applied inheritance, data structures, and problem-solving in coursework.',
      journey: 'Started learning early, solving complex problems and DSA challenges to build strong algorithmic thinking before college.'
    },
  ],
  [


    {
      id: 8,
      skill: 'MongoDb',
      logo: mongodb,
      background: '#d0e2ed',
      color: '#4DB33D',
      whereLearned: ['Self-learned'],
      level: 'Beginner',
      percentage: 45,
      projects: [],
      description: 'NoSQL database for flexible data storage. Used in course project for handling dynamic datasets with JSON-like documents.',
      journey: 'Integrated MongoDB in full-stack projects to store and retrieve dynamic data efficiently, especially for APIs and dashboards.'
    },
    {
      id: 1,
      skill: 'Jquery',
      logo: jquery,
      background: 'white',
      color: '#0769ad',
      whereLearned: ['School'],
      level: 'Intermediate',
      percentage: 65,
      projects: ['Dynamic form validation tool'],
      description: 'Simplifies DOM manipulation, event handling, and animations. Used for building interactive forms and quick prototypes in academic and personal projects.',
      journey: 'Learned during college coursework and applied in various academic projects to quickly manipulate DOM elements and create interactive experiences.'
    },
    {
      id: 3,
      skill: 'TypeScript',
      logo: ts,
      background: '#3178c6',
      color: '#D9D9D9',
      whereLearned: ['Self-learned'],
      level: 'Intermediate',
      percentage: 70,
      projects: ['React project with type safety'],
      description: 'Strongly typed JavaScript for scalable apps. Improved project maintainability and reduced bugs in React projects.',
      journey: 'Adopted TypeScript to make projects more robust and reduce errors, particularly in React apps with complex state management.'
    },
    {
      id: 4,
      skill: 'MySql',
      logo: sql,
      background: 'black',
      color: '#4479A1',
      whereLearned: ['Certification'],
      level: 'Intermediate',
      percentage: 68,
      projects: ['Student database management system'],
      description: 'Relational database for structured data. Gained experience in schema design, queries, and building reliable data layers.',
      journey: 'Completed certification to master SQL queries and database handling, enabling me to tackle complex data storage and retrieval tasks efficiently.'
    },
    {
      id: 5,
      skill: 'Bootstrap',
      logo: bootstrap,
      background: '#5e3b7f',
      color: '#FFFFFF',
      whereLearned: ['School'],
      level: 'Intermediate',
      percentage: 70,
      projects: ['Personal portfolio website'],
      description: 'Front-end toolkit with responsive grids and components. Used for quick, clean layouts and portfolio development.',
      journey: 'Used extensively in college projects for fast, responsive layouts and polished UI components.'
    },
  ],
];












// export const Skills =
// [
//     {
//         skill: 'Html5',
//         logo: html,
//         pos: [13, 15, 15],
//     },
//     {
//         skill: 'Css3',
//         logo: css,
//         pos: [13, 12, 15],
//     },
//     {
//         skill: 'JavaScript',
//         logo: js,
//         pos: [13, 9, 15],
//     },
//     {
//         skill: 'Jquery',
//         logo: jquery,
//         pos: [13, 6, 15],
//     },
//     {
//         skill: 'React Js',
//         logo: react,
//         pos: [13, 3, 15],
//     },
//     {
//         skill: 'Node Js',
//         logo: node,
//         pos: [13, 0, 15],
//     },
//     {
//         skill: 'Three Js',
//         logo: three,
//         pos: [13, -3, 15],
//     },
//     {
//         skill: 'TypeScript',
//         logo: ts,
//         pos: [5, -6, 15],
//     },
//     {
//         skill: 'C/Java',
//         logo: java,
//         pos: [-3, 15, 15],
//     },
//     {
//         skill: 'MySql',
//         logo: sql,
//         pos: [-3, 12, 15],
//     },
//     {
//         skill: 'MongoDb',
//         logo: mongodb,
//         pos: [-3, 9, 15],
//     },
//     {
//         skill: 'Postman',
//         logo: postman,
//         pos: [-3, 6, 15],
//     },
//     {
//         skill: 'Git/Github',
//         logo: github,
//         pos: [-3, 3, 15],
//     },
//     {
//         skill: 'Bootstrap',
//         logo: bootstrap,
//         pos: [-3, 0, 15],
//     },
//     {
//         skill: 'Gsap',
//         logo: gsap,
//         pos: [-3, -3, 15],
//     },

// ];